import type { GridColumn } from '../../../components/tables/EditableGrid';

/**
 * Quote line-item grid columns.
 *
 * The grid is the EDITING surface: `UnitPrice` is entered by the user and is
 * STORED in CAD (the base currency the quoteCalculator works in). To avoid an
 * edit-vs-display currency mismatch, the grid always shows CAD — the headers are
 * explicitly labelled "(CAD)". When the quote currency is USD, the converted,
 * customer-facing amounts appear in the right-rail summary and on the PDF
 * (BUG-2026-0120 #6); a note next to the grid points this out. Keeping the grid
 * in CAD makes the base prices unambiguous while the summary/PDF present the
 * quote in its chosen currency — internally consistent (same CAD base, one
 * conversion at the presentation layer).
 */
export const quoteLineItemColumns: GridColumn[] = [
  { field: 'LineNumber', headerName: '#', type: 'number', width: 35, readonly: true },
  { field: 'AstmCode', headerName: 'ASTM', type: 'text', width: 75 },
  { field: 'Description', headerName: 'Test Name', type: 'text', flex: 1 },
  {
    field: 'UnitPrice', headerName: 'Price (CAD)', type: 'number', width: 100,
    formatCurrency: true, currency: 'CAD', fxRateToCad: 1,
  },
  { field: 'Quantity', headerName: 'No. of Tests', type: 'number', width: 85, showSpinButtons: true },
  {
    field: 'LineTotal', headerName: 'Total (CAD)', type: 'number', width: 100, readonly: true,
    formatCurrency: true, currency: 'CAD', fxRateToCad: 1,
  },
  { field: 'LabNote', headerName: 'Notes', type: 'text', width: 150 },
];
